
export const SITE_URL = (process.env.REACT_APP_SITE_URL || process.env.REACT_APP_BACKEND_URL).replace(/\/$/, "");
export const SITE_NAME = "H&W Furniture";
const abs = (u) => (u.startsWith("http") ? u : `${SITE_URL}${u}`);

export const Seo = ({ title, description, path = "/", image = "/og-image.jpg", type = "website", noindex = false, jsonLd = [] }) => (
  <>
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"} />
    <link rel="canonical" href={abs(path)} />
    <meta property="og:type" content={type} />
    <meta property="og:site_name" content={SITE_NAME} />
    <meta property="og:locale" content="en_IN" />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={abs(path)} />
    <meta property="og:image" content={abs(image)} />
    {image === "/og-image.jpg" && <meta property="og:image:width" content="1200" />}
    {image === "/og-image.jpg" && <meta property="og:image:height" content="630" />}
    <meta property="og:image:alt" content={title} />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={abs(image)} />
    {jsonLd.map((j, i) => (
      <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(j) }} />
    ))}
  </>
);

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: abs(path) })),
});

export const faqLd = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })),
});

const dims = (p) => {
  const m = /([\d.]+) W x ([\d.]+) D x ([\d.]+) H/.exec(p.dimensions || "");
  return m ? { width: { "@type": "QuantitativeValue", value: +m[1], unitCode: "CMT" }, depth: { "@type": "QuantitativeValue", value: +m[2], unitCode: "CMT" }, height: { "@type": "QuantitativeValue", value: +m[3], unitCode: "CMT" } } : {};
};

export const productLd = (p) => ({
  "@context": "https://schema.org",
  "@type": "ProductGroup",
  name: `${p.name} – ${p.category === "modules" ? "Pustak Rack add-on module" : "DIY modular bookshelf"}`,
  description: p.description,
  brand: { "@type": "Brand", name: SITE_NAME },
  productGroupID: p.slug,
  variesBy: ["https://schema.org/color"],
  url: abs(`/product/${p.slug}`),
  material: p.material,
  ...dims(p),
  category: p.category === "modules" ? "Furniture > Shelving > Modular storage accessories" : "Furniture > Shelving > Modular bookshelves",
  ...(p.review_count > 0 && { aggregateRating: { "@type": "AggregateRating", ratingValue: p.rating, reviewCount: p.review_count } }),
  hasVariant: (p.variants.length ? p.variants : [{ key: "", name: "", images: p.images, sku: p.slug }]).map((v) => ({
    "@type": "Product",
    name: v.name ? `${p.name} – ${v.name}` : p.name,
    sku: v.sku,
    color: v.name || undefined,
    image: v.images.map(abs),
    offers: {
      "@type": "Offer",
      url: abs(`/product/${p.slug}${v.key ? `?finish=${v.key}` : ""}`),
      priceCurrency: "INR",
      price: p.gst_exclusive ? Math.round(p.price * (1 + p.gst_rate / 100)) : p.price,
      availability: "https://schema.org/InStock",
      itemCondition: "https://schema.org/NewCondition",
      areaServed: { "@type": "City", name: "Hyderabad" },
      shippingDetails: {
        "@type": "OfferShippingDetails",
        shippingRate: { "@type": "MonetaryAmount", value: 0, currency: "INR" },
        shippingDestination: { "@type": "DefinedRegion", addressCountry: "IN", addressRegion: "TG" },
        deliveryTime: {
          "@type": "ShippingDeliveryTime",
          handlingTime: { "@type": "QuantitativeValue", minValue: 0, maxValue: 0, unitCode: "DAY" },
          transitTime: { "@type": "QuantitativeValue", minValue: 1, maxValue: 1, unitCode: "DAY" },
        },
      },
      hasMerchantReturnPolicy: {
        "@type": "MerchantReturnPolicy",
        applicableCountry: "IN",
        returnPolicyCategory: "https://schema.org/MerchantReturnFiniteReturnWindow",
        merchantReturnDays: 10,
      },
    },
  })),
});
